import { render, staticRenderFns } from "./AppealsTable.vue?vue&type=template&id=02ae9bfc&scoped=true&"
import script from "./AppealsTable.vue?vue&type=script&lang=js&"
export * from "./AppealsTable.vue?vue&type=script&lang=js&"
import style0 from "./AppealsTable.vue?vue&type=style&index=0&id=02ae9bfc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02ae9bfc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VDataTable})
